import { render, staticRenderFns } from "./eod-products.vue?vue&type=template&id=4390ec7a"
import script from "./eod-products.vue?vue&type=script&lang=js"
export * from "./eod-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports